import { useSyncExternalStore } from 'react';
import { getPresentation, getPresentationMode, subscribePresentation } from '../presentation/runtime';

export default function GoodvaleLogo({
  className = 'h-9 w-9',
  alt = 'Goodvale Logo',
  glow = false,
}) {
  useSyncExternalStore(subscribePresentation, getPresentationMode);
  return (
    <img
      src={getPresentation().logo}
      alt={alt}
      className={`object-contain transition-transform duration-300 ${glow ? 'drop-shadow-[0_0_8px_rgba(238,216,171,0.25)] hover:drop-shadow-[0_0_12px_rgba(238,216,171,0.45)]' : ''} ${className}`}
    />
  );
}
